import * as CONFIGS from '@/statics/configs.js';

const NODE5 = {
  NAME: 'S1GP-TE10',
  INPUT1: {
    NAME: 'NODE5_INPUT1_NAME',
    TYPE: 'zeroContact',
    ICON: 'switch',
    PARAMETER_ID: 0x8020,
  },
  OUTPUT1: {
    NAME: 'NODE5_OUTPUT1_NAME',
    TYPE: 'RelaySSR2A',
    ICON: 'lamp',
    PARAMETER_ID: 0xE010,
  },
  TEMPERATURE: {
    NAME: 'NODE5_TEMPERATURE_NAME',
    TYPE: 'internalTemperature',
    ICON: 'temperature',
    PARAMETER_ID: 0x8101,
  },
  NOTIFY_HUB: {
    PARAMETER_ID: 0x6100,
  },
  RELAY1_INIT: {
    PARAMETER_ID: 0xE110,
  },
  LORA_RSSI: {
    PARAMETER_ID: 0x8102,
  },
  LORA_SNR: {
    PARAMETER_ID: 0x8103,
  },
}
NODE5.DEFAULT_INSTRUCTIONS = [
  [
    {
      eventToWatch: {
        parameterId: NODE5.INPUT1.PARAMETER_ID,
        valueToReach: 1,
        direction: CONFIGS.EVENT_DIRECTION_RISING
      },
      internalAction: {
        parameterId: NODE5.OUTPUT1.PARAMETER_ID,
        valueOfChange: 0,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE5.INPUT1.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE5.OUTPUT1.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE5.INPUT1.PARAMETER_ID,
        valueToReach: 1,
        direction: CONFIGS.EVENT_DIRECTION_RISING
      },
      internalAction: {
        parameterId: NODE5.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE5.INPUT1.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE5.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
    },
  ],
  [
    {
      eventToWatch: {
        parameterId: NODE5.INPUT1.PARAMETER_ID,
        valueToReach: 1,
        direction: CONFIGS.EVENT_DIRECTION_RISING
      },
      internalAction: {
        parameterId: NODE5.OUTPUT1.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE5.INPUT1.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE5.OUTPUT1.PARAMETER_ID,
        valueOfChange: 0,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE5.INPUT1.PARAMETER_ID,
        valueToReach: 1,
        direction: CONFIGS.EVENT_DIRECTION_RISING
      },
      internalAction: {
        parameterId: NODE5.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE5.INPUT1.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE5.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
    },
  ],
  [
    {
      eventToWatch: {
        parameterId: NODE5.INPUT1.PARAMETER_ID,
        valueToReach: 1,
        direction: CONFIGS.EVENT_DIRECTION_RISING
      },
      internalAction: {
        parameterId: NODE5.OUTPUT1.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_TOGGLE,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE5.INPUT1.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE5.OUTPUT1.PARAMETER_ID,
        valueOfChange: 0,
        typeOfAction: CONFIGS.ACTION_TYPE_TOGGLE,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE5.INPUT1.PARAMETER_ID,
        valueToReach: 1,
        direction: CONFIGS.EVENT_DIRECTION_RISING
      },
      internalAction: {
        parameterId: NODE5.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE5.INPUT1.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE5.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
    },
  ],
  [
    {
      eventToWatch: {
        parameterId: NODE5.INPUT1.PARAMETER_ID,
        valueToReach: 1,
        direction: CONFIGS.EVENT_DIRECTION_RISING
      },
      internalAction: {
        parameterId: NODE5.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
      timeDelay: 0
    },
    {
      eventToWatch: {
        parameterId: NODE5.INPUT1.PARAMETER_ID,
        valueToReach: 0,
        direction: CONFIGS.EVENT_DIRECTION_FALLING
      },
      internalAction: {
        parameterId: NODE5.NOTIFY_HUB.PARAMETER_ID,
        valueOfChange: 1,
        typeOfAction: CONFIGS.ACTION_TYPE_SET,
      },
    },
  ],
]

NODE5.DIRECT_INSTRUCTIONS_TO_SET_OUTPUT = [
  {
    eventToWatch: {
      parameterId: NODE5.INPUT1.PARAMETER_ID,
      valueToReach: 1,
      direction: CONFIGS.EVENT_DIRECTION_RISING
    },
    internalAction: {
      parameterId: NODE5.OUTPUT1.PARAMETER_ID,
      valueOfChange: 0,
      typeOfAction: CONFIGS.ACTION_TYPE_SET,
    },
    timeDelay: 0
  },
  {
    eventToWatch: {
      parameterId: NODE5.INPUT1.PARAMETER_ID,
      valueToReach: 0,
      direction: CONFIGS.EVENT_DIRECTION_FALLING
    },
    internalAction: {
      parameterId: NODE5.OUTPUT1.PARAMETER_ID,
      valueOfChange: 1,
      typeOfAction: CONFIGS.ACTION_TYPE_SET,
    },
    timeDelay: 0
  },
]
NODE5.DIRECT_INSTRUCTIONS_TO_NOTIFY_HUB = [
  {
    eventToWatch: {
      parameterId: NODE5.INPUT1.PARAMETER_ID,
      valueToReach: 1,
      direction: CONFIGS.EVENT_DIRECTION_RISING
    },
    internalAction: {
      parameterId: NODE5.NOTIFY_HUB.PARAMETER_ID,
      valueOfChange: 1,
      typeOfAction: CONFIGS.ACTION_TYPE_SET,
    },
    timeDelay: 0
  },
  {
    eventToWatch: {
      parameterId: NODE5.INPUT1.PARAMETER_ID,
      valueToReach: 0,
      direction: CONFIGS.EVENT_DIRECTION_FALLING
    },
    internalAction: {
      parameterId: NODE5.NOTIFY_HUB.PARAMETER_ID,
      valueOfChange: 1,
      typeOfAction: CONFIGS.ACTION_TYPE_SET,
    },
  }
]
NODE5.DIRECT_INSTRUCTIONS_TO_NOTIFY_HUB_ON_TIMER = [
  ...NODE5.DIRECT_INSTRUCTIONS_TO_NOTIFY_HUB,
  {
    eventToWatch: {
      parameterId: NODE5.OUTPUT1.PARAMETER_ID,
      valueToReach: 0,
      direction: CONFIGS.EVENT_DIRECTION_FALLING
    },
    internalAction: {
      parameterId: NODE5.NOTIFY_HUB.PARAMETER_ID,
      valueOfChange: 1,
      typeOfAction: CONFIGS.ACTION_TYPE_SET,
    },
  }
]

NODE5.DIRECT_INSTRUCTIONS_TO_CLEAR_PENDING_INSTRUCTIONS = [
  {
    eventToWatch: {
      parameterId: NODE5.INPUT1.PARAMETER_ID,
      valueToReach: 0,
      direction: CONFIGS.EVENT_DIRECTION_FALLING
    },
    internalAction: {
      parameterId: CONFIGS.CLEAR_PENDING_ACTIONS_ON_OUTPUT1,
      valueOfChange: 1,
      typeOfAction: CONFIGS.ACTION_TYPE_SET,
    },
    timeDelay: 0
  },
]

NODE5.INDIRECT_INSTRUCTIONS_TO_SET_OUTPUT = [
  {
    eventToWatch: {
      parameterId: NODE5.INPUT1.PARAMETER_ID,
      valueToReach: 1,
      direction: CONFIGS.EVENT_DIRECTION_RISING
    },
    internalAction: {
      parameterId: NODE5.OUTPUT1.PARAMETER_ID,
      valueOfChange: 1,
      typeOfAction: CONFIGS.ACTION_TYPE_SET,
    },
    timeDelay: 0
  },
  {
    eventToWatch: {
      parameterId: NODE5.INPUT1.PARAMETER_ID,
      valueToReach: 0,
      direction: CONFIGS.EVENT_DIRECTION_FALLING
    },
    internalAction: {
      parameterId: NODE5.OUTPUT1.PARAMETER_ID,
      valueOfChange: 0,
      typeOfAction: CONFIGS.ACTION_TYPE_SET,
    },
    timeDelay: 0
  },
]
NODE5.INDIRECT_INSTRUCTIONS_TO_CLEAR_PENDING_INSTRUCTIONS = [
  {
    eventToWatch: {
      parameterId: NODE5.INPUT1.PARAMETER_ID,
      valueToReach: 1,
      direction: CONFIGS.EVENT_DIRECTION_RISING
    },
    internalAction: {
      parameterId: CONFIGS.CLEAR_PENDING_ACTIONS_ON_OUTPUT1,
      valueOfChange: 1,
      typeOfAction: CONFIGS.ACTION_TYPE_SET,
    },
    timeDelay: 0
  },
]


export default NODE5;